import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CreditCardIcon,
  CertificateIcon,
  CalendarCheckIcon,
} from "@phosphor-icons/react";

import api from "../../lib/api";

function fmtCents(cents) {
  if (cents === null || cents === undefined) return "—";
  return `$${(cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

/**
 * Three KPI tiles backed by /subscriptions/metrics/summary.
 * Office only — caller is responsible for guarding by role.
 */
export default function MrrTile() {
  const [metrics, setMetrics] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    api
      .get("/subscriptions/metrics/summary")
      .then((r) => {
        if (!cancelled) setMetrics(r.data);
      })
      .catch(() => {
        // Tech roles get 403 — silently leave nothing rendered
        if (!cancelled) setMetrics(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!metrics) return null;

  const tiles = [
    {
      label: "Active plans",
      value: metrics.active_count,
      icon: CertificateIcon,
      tint: "text-emerald-700 bg-emerald-50 border-emerald-200",
      to: "/subscriptions?status=active",
      testid: "tile-active-plans",
    },
    {
      label: "Monthly recurring revenue",
      value: fmtCents(metrics.mrr_cents),
      icon: CreditCardIcon,
      tint: "text-amber-800 bg-amber-50 border-amber-200",
      to: "/subscriptions",
      testid: "tile-mrr",
    },
    {
      label: "Renewing in 30 days",
      value: metrics.renewing_next_30_days_count,
      icon: CalendarCheckIcon,
      tint: "text-sky-800 bg-sky-50 border-sky-200",
      to: "/subscriptions?renewing_soon=1",
      testid: "tile-renewing",
    },
  ];

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-3 gap-4"
      data-testid="mrr-tiles"
    >
      {tiles.map((t) => {
        const Icon = t.icon;
        return (
          <button
            key={t.testid}
            type="button"
            onClick={() => nav(t.to)}
            data-testid={t.testid}
            className="text-left rounded-md border border-slate-200 bg-white px-4 py-4 hover:border-amber-300 hover:shadow-card transition-all group"
          >
            <div
              className={`inline-flex h-9 w-9 items-center justify-center rounded-md border ${t.tint} mb-3`}
            >
              <Icon size={18} weight="duotone" />
            </div>
            <div className="font-heading text-2xl font-bold text-slate-900">
              {t.value}
            </div>
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mt-1">
              {t.label}
            </div>
          </button>
        );
      })}
    </div>
  );
}
